import { LocalStorageCompatible } from './local-storage-compatible';
import {
  isLocalStorageV14,
  LocalStorageV14,
  SearchCriterion as LegacySearchCriterion,
  SearchQuery as LegacySearchQuery,
} from './local-storage-v14';
import { upgrade as upgradeFromPrevious } from './local-storage-v14.upgrade';
import { LocalStorageV15, SearchCriterion, SearchQuery } from './local-storage-v15';

/*
 * NOTE: Create new migration files only when you need to remove or edit existing field. Do not create new migration file for adding new field.
 */
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV15> {
  const input: LocalStorageV14 = isLocalStorageV14(raw) ? raw : await upgradeFromPrevious(raw);
  const { data } = input;

  const { recentSearchQueries, ...rest } = data;

  const newRecentSearchQueries: Record<
    string,
    Record<string, SearchQuery[] | undefined> | undefined
  > = {};

  for (const [key, container] of Object.entries(recentSearchQueries || {})) {
    const newContainer: Record<string, SearchQuery[] | undefined> = {};

    for (const [key2, query] of Object.entries(container || [])) {
      if (query !== undefined && areV15Queries(query)) {
        newContainer[key2] = query;
      }
    }

    if (Object.keys(newContainer).length > 0) {
      newRecentSearchQueries[key] = newContainer;
    }
  }

  return {
    version: 15,
    data: {
      ...rest,
      ...(Object.keys(newRecentSearchQueries).length > 0
        ? { recentSearchQueries: newRecentSearchQueries }
        : {}),
    },
  };
}

function areV15Queries(query: LegacySearchQuery[] = []): query is SearchQuery[] {
  return query.every(isV15Query);
}

function isLegacyCriterion(
  test: LegacySearchCriterion | LegacySearchQuery,
): test is LegacySearchCriterion {
  return (test as LegacySearchCriterion).type !== undefined;
}

function isV15Query(query: LegacySearchQuery): query is SearchQuery {
  return query.criteria.every((criteria) =>
    isLegacyCriterion(criteria) ? isV15Criterion(criteria) : isV15Query(criteria),
  );
}

function isV15Criterion(criterion: LegacySearchCriterion): criterion is SearchCriterion {
  if (criterion.type !== undefined) {
    if (criterion.type === 'stage') {
      return false;
    }
  }

  return true;
}
